import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "../../InputField";
import exportImage from "../../../asset/Images";
import axios from "axios";
import { useMutation, useQuery } from "react-query";
import Popup from "../../popupmodal/Popup";

export default function InvoiceCom() {
  const storedBranchArray =
    JSON.parse(sessionStorage.getItem("branchNames")) || [];
  const [selectBranch, setSelectedBranch] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isSpinning, setIsSpinning] = useState(false);
  const [searchBtnShow, setSearchBtnShow] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });
  const [filteredData, setFilteredData] = useState([]);
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const { invoiceNo, customerName, siteName } = watch();

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // GET API START
  const invoiceData = async () => {
    return await axios.get(
      `${process.env.REACT_APP_HOST}/invoice/${selectBranch}/all`
    );
  };

  const { data, isLoading, isError, refetch } = useQuery(
    ["invoiceData", selectBranch],
    invoiceData,
    {
      enabled: !!selectBranch,
      refetchOnWindowFocus: false,
    }
  );
  // GET API END

  const allData = data?.data || [];

  useEffect(() => {
    if (allData?.length > 0 && filteredData?.length === 0) {
      setFilteredData(allData); // Set initial state to all data, but only once
    }
  }, [allData, filteredData]);

  const handleSearch = () => {
    const filtered = allData.filter((item) => {
      const matchProjectNo = invoiceNo
        ? item?.invoiceNo?.toLowerCase().includes(invoiceNo.toLowerCase())
        : false;

      const matchCustomerName = customerName
        ? item?.customerName?.toLowerCase().includes(customerName.toLowerCase())
        : false;

      const matchSiteName = siteName
        ? item?.site_address?.toLowerCase().includes(siteName.toLowerCase())
        : false;

      // Match if any of the fields match
      return matchProjectNo || matchCustomerName || matchSiteName;
    });

    setFilteredData(filtered);
  };

  // Clear search Data
  const handleClear = () => {
    reset({
      projectNo: "",
      customerName: "",
      siteName: "",
    });
    setFilteredData(allData);
  };
  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows =
    filteredData && filteredData?.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(
    filteredData && filteredData?.length / rowsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { mutate, isLoading: deleteLoading } = useMutation(
    async (deleteId) => {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_HOST}/invoice/${selectBranch}/${deleteId}`
        );
        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error; // To trigger onError
      }
    },
    {
      onSuccess: () => {
        console.log("Invoice deleted successfully");
        refetch(); 
        setPopupType({
          type: "delete success",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to delete invoice. Please try again.");
      },
    }
  );

  const handleDelete = () => {
    if (deleteId) {
      mutate(deleteId);
    } else {
      alert("No invoice selected for deletion.");
    }
  };
  useEffect(() => {
    const savedBranch = sessionStorage.getItem("selectedBranch");
    if (savedBranch) {
      setValue("branchSelect", savedBranch);
      setSelectedBranch(savedBranch);
    }
  }, []);
  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">Invoice </div>
            <div
              className="header_Btn_container"
              onClick={() => {
                navigate("/invoice/addInvoice");
              }}
            >
              Add Invoice
            </div>
          </header>
          <section className="viewPageSectionContainer">
            <div className="searchInputMainContainer">
              <div className="searchInput">
                <label className="searchInputLabel">Invoice No</label>
                <Controller
                  control={control}
                  name="invoiceNo"
                  render={(field) => (
                    <InputField
                      {...field}
                      type="text"
                      searchInputCss="searchInputCss"
                    />
                  )}
                />
              </div>
              <div className="searchInput">
                <label className="searchInputLabel">Customer Name</label>
                <Controller
                  control={control}
                  name="customerName"
                  render={(field) => (
                    <InputField
                      {...field}
                      type="text"
                      searchInputCss="searchInputCss"
                    />
                  )}
                />
              </div>
              <div className="searchInput">
                <label className="searchInputLabel">Site Name</label>
                <Controller
                  control={control}
                  name="siteName"
                  render={(field) => (
                    <InputField
                      {...field}
                      type="text"
                      searchInputCss="searchInputCss"
                    />
                  )}
                />
              </div>

              <div className="d-flex align-items-center gap-2">
                <button className="header_Btn_container" onClick={handleSearch}>
                  Search
                </button>

                {(invoiceNo || customerName || siteName) && (
                  <button
                    className="header_Btn_container"
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                )}
              </div>
              <div className="searchInput">
                <Controller
                  name="branchSelect"
                  control={control}
                  rules={{ required: "Branch selection is required" }}
                  render={({ field }) => (
                    <select
                      {...field}
                      className="searchSelectCss"
                      onChange={(e) => {
                        field.onChange(e); // Update form state
                        setSelectedBranch(e.target.value); // Update local state
                        sessionStorage.setItem(
                          "selectedBranch",
                          e.target.value
                        );
                      }}
                      value={field.value || ""}
                    >
                      <option value="">-Select Branch-</option>
                      {storedBranchArray?.map((branch, index) => (
                        <option key={index} value={branch}>
                          {branch}
                        </option>
                      ))}
                    </select>
                  )}
                />
                {errors.branchSelect && (
                  <p style={{ color: "red" }}>{errors.branchSelect.message}</p>
                )}
              </div>
            </div>

            <div className="tableMainContainer">
              <table className="tableMain">
                <thead>
                  <tr className="tableHeadRow">
                    <td className="tableHeaderTxt ">Invoice No</td>
                    <td className="tableHeaderTxt ">Customer Name</td>
                    <td className="tableHeaderTxt ">Site Name</td>
                    <td className="tableHeaderTxt ">Mobile No</td>
                    <td
                      className="tableHeaderTxt "
                      style={{
                        width: "260px",
                      }}
                    >
                      Branch
                    </td>
                    <td
                      className="tableHeaderTxt "
                      style={{
                        width: "260px",
                      }}
                    >
                      Action
                    </td>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {isLoading ? (
                    <>
                      {/* <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <div className="loader"></div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr> */}
                      <h6 className="mt-3 px-3">L O A D I N G . . .</h6>
                    </>
                  ) : currentRows?.length > 0 ? (
                    currentRows &&
                    currentRows?.map((item, index) => {
                      return (
                        <tr>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.invoiceNo || "-"}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.customerName || "-"}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.siteAddress || "-"}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.mobileNo || "-"}
                          </td>
                          <td
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                            className="tableDataTxt"
                          >
                            {item?.branch || "-"}
                          </td>
                          <td
                            className="tableDataTxt "
                            style={{
                              width: "260px",
                              height: "100%",
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                          >
                            <div className="d-flex gap-1 align-items-center">
                              <div
                                className="actionBtn"
                                onClick={() => {
                                  navigate("/invoice/addInvoice", {
                                    state: item,
                                  });
                                }}
                              >
                                <img
                                  className="mb-1"
                                  src={exportImage?.editIcon}
                                  alt="editIcon"
                                />
                              </div>
                              <div
                                className="actionBtn"
                                onClick={() => {
                                  setIsModalOpen(true);
                                  setPopupType({
                                    ...popupType,
                                    type: "confirm delete",
                                  });
                                  setDeleteId(item?.id);
                                }}
                              >
                                <img
                                  className="mb-1"
                                  src={exportImage?.deleteIcon}
                                  alt="deleteIcon"
                                />
                              </div>
                              <div
                                className="actionBtn"
                                onClick={() => {
                                  navigate("/invoice/invoiceBill", {
                                    state: item,
                                  });
                                }}
                              >
                                <img
                                  className="mb-1"
                                  src={exportImage?.downloadIcon}
                                  alt="downloadIcon"
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <p className="noDataFoundTxt">No Data Found</p>
                  )}
                </tbody>
              </table>
            </div>
          </section>
          <nav aria-label="Page navigation example" className="mt-2">
            <ul className="pagination justify-content-center">
              {/* Previous Button */}
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
              </li>

              {/* Page Numbers */}
              {Array?.from({ length: totalPages })?.map((_, index) => {
                const pageNumber = index + 1;
                const isActive = currentPage === pageNumber;

                return (
                  <li
                    key={pageNumber}
                    className={`page-item ${isActive ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              })}

              {/* Next Button */}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &raquo;
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <Popup
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        handleDelete={handleDelete}
        deleteLoading={deleteLoading}
        message="Are you sure you want to delete the invoice details?"
      />
    </>
  );
}
